//人工回访
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div class="grid-height"   style=" height: calc(100vh - -72px);">
          <vxe-grid show-overflow :stripe="true" border="default" height="100%" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
          >

            <template #form>
              <div class="clearfix screen-btns" style="padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-top"
                              @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <el-input placeholder="请输入工单号或用户联系方式" style="width: 200px;     height: 27px !important;"
                            v-model="searchValue" @keyup.enter.native="searchEvent" clearable>
                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                  </el-input>
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 0 0 10px;"
                              class="button-sty" @click="searchEvent">搜索
                  </vxe-button>

                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form  ref="form" class="screen-box" title-width="7vw"
                          title-align="right" :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent" >
                  <vxe-form-item title="异常回访标签:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.recallTag"  clearable style="width:7vw ;">
                        <!--                        <el-option :value="null" label="全部"></el-option>-->
                        <el-option :value="1" label="当天同号码多单完工"></el-option>
                        <el-option :value="2" label="事后单"></el-option>
                        <el-option :value="3" label="多单来源不规范"></el-option>
                        <el-option :value="4" label="七天内先调试再维修"></el-option>
                        <el-option :value="5" label="指定服务商/工程师"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.ServiceType')+':'" field="name">
                    <template v-slot>
                      <service-type-cascader style="width:7vw;"
                                             @selectedServiceType="data => { formData.serviceTypeId = data }"/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item :title="$t('common.SourceWorkOrder')+':'" field="name">
                    <template v-slot>
                      <order-type-select style="width:7vw;" :order-type-id.sync="formData.orderTypeId"/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.ServiceProvider')+':'" field="name">
                    <template v-slot>
                      <site-search :site-id.sync="formData.siteId" style="width:7vw ;"/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.TimeCompletion')+':'" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;" v-model="formData.completeDate" type="daterange"
                                      align="right"
                                      unlink-panels range-separator="-"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == index,
											btnGoodsStatusBt: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from '@/views/workorder/return/robot/edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";
import SiteSearch from "@/components/formItem/siteSearch.vue";
import ServiceTypeCascader from "@/components/formItem/serviceTypeCascader.vue";
import OrderTypeSelect from "@/components/formItem/orderTypeSelect.vue";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
export default {
  name: 'visit',
  inject: ['reload'],
  components: {editView,pager,SiteSearch,OrderTypeSelect,
    ServiceTypeCascader},
  data() {
    return {
      total: 0,
      searchValue: null,
      brandOptions: [],
      userOptions: [],
      orderTypeOptions: [],
      serviceTypeOption: [],
      dispatchStatOptions: [],
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      requestParam: {
        recallTag:null,
        userName: null,
        userMobile: null,

        completeTimeBegin: null,
        completeTimeEnd: null,
        searchValueIsEnable: false,
        tabStat: '异常工单',

        serviceTypeId: null,
        siteId: null,
        createBy: null,
        orderTypeId: null,

        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
      },
      //////////////////////////////////////////////////////////////
      formData: {
        userName: null,
        userMobile: null,
        completeDate: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        searchValue: null,
        orderTypeId: null,
        serviceTypeId: null,
        siteId: null,
        createBy: null,
        siteName: null,
        recallTag:null
      },
      show3: false,

      sitePromptList: [],

      goodsStatusList: [ //循环列表
        { name: "异常工单", num: 0 },
        { name: "超期未回访", num: 0 },
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      // 查询参数


      pageSizes: [10, 50, 100,1000],

      showEdit: false,

      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {
          title: '工单号',
          field: 'orderNo',
          width: 210,
          slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.orderNo}</span>
              ]
            }
          }
        },
        {
          title: '异常标签',
          field: 'recallTag',
          width: 125,
          slots: {
            default: ({row}) => {
              if (row.recallTag == 1) {
                return [
                  <div class="txt-status neutral">
                    <span>当天同号码多单完工</span>
                  </div>
                ];
              } else if (row.recallTag == 2) {
                return [
                  <div class="txt-status disable">
                    <span>事后单</span>
                  </div>
                ];
              } else if (row.recallTag == 3) {
                return [
                  <div class="txt-status ">
                    <span>多单来源不规范</span>
                  </div>
                ];
              } else if (row.recallTag == 4) {
                return [
                  <div class="txt-status ">
                    <span>七天内先调试再维修</span>
                  </div>
                ];
              } else if (row.recallTag == 5) {
                return [
                  <div class="txt-status ">
                    <span>指定服务商/工程师</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '服务类型',
          field: 'serverTypeName',
          width: 80,
        },
        {
          title: '用户姓名',
          field: 'userName',
          width: 80,
        },
        {
          title: '用户电话',
          field: 'userMobile',
          width: 120,
        },
        {
          title: '产品大类',
          field: 'bigCategoryName',
          width: 100,
          // fixed: 'left'
        },
        {
          title: '购买渠道',
          field: 'buyChannelName',
          width: 150,
        },
        {
          title: '工单状态',
          field: 'orderStatName',
          width: 100,
          // fixed: 'left'
        },
        {
          title: '服务商',
          field: 'siteName',
          width: 150,
        },
        {
          title: '完工时间',
          field: 'completeTime',
          width: 150,
        },
        {
          title: '创建时间',
          field: 'createTime',
          width: 150,
        },
        {
          title: '回访状态',
          field: 'recallStat',
          width: 125,
          slots: {
            default: ({row}) => {
              if (row.recallStat == 0) {
                return [
                  <div class="txt-status neutral">
                    <span>未回访</span>
                  </div>
                ];
              } else if (row.recallStat == 1) {
                return [
                  <div class="txt-status disable">
                    <span>回访失败</span>
                  </div>
                ];
              } else if (row.recallStat == 5) {
                return [
                  <div class="txt-status ">
                    <span>回访成功</span>
                  </div>
                ];
              } else if (row.recallStat == 99) {
                return [
                  <div class="txt-status ">
                    <span>待人工回访</span>
                  </div>
                ];
              }
            }
          }
        },
      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
        this.loadTabOption()
      }
    },
    'formData.completeDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.completeTimeBegin = newVal[0]
          this.formData.completeTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.completeTimeBegin = null
          this.formData.completeTimeEnd = null
        }
      },
      deep: true,
    },
  },
  created() {

  },

  mounted() {
    this.loadTabOption()
    this.loadOrderTypeOption()
    this.loadServiceTypeOptions()
    this.initSearchDate()
  },

  methods: {
    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
      start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.completeDate = [start, end]
      this.requestParam.completeTimeBegin = start
      this.requestParam.completeTimeEnd= end
    },
    //导出
    doExcle() {
      // const  result =
      this.$mask.open()
      this.$objCopy(this.formData, this.requestParam)
      doCheckExcle(fileNames.exceptionRecall).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle(api.exceptionRecall.getListByExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
      this.loadTabOption()

    },

    loadDispatchStatOptions() {
      this.$http({
        url: api.basDispatchStat.getList,
        method: 'post',
        data: {
          isShow: 1  //工单查询栏目是否显示:0否1是
        }
      }).then(res => {
        this.dispatchStatOptions = []
        res.data.data.forEach(item =>  {
          this.dispatchStatOptions.push({label:item.dispatchStat})
        })
      })
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },

    serviceTypeHandleChange(data) {
      console.log('选中的服务类型数据', data)
    },

    // 加载服务类型
    loadServiceTypeOptions() {
      this.$http({
        url: api.basServiceType.getOptionUrl,
        method: 'post',
        data: {}
      }).then(res => {
        // console.log(res.data.data, 'option')
        let list = [{value: null, label: '全部'}]
        res.data.data.forEach(item => {
          if (item.children.length == 0) {
            delete item.children
          }
          list.push(item)
        })
        this.serviceTypeOption = list
      })
    },

    // 加载工单来源
    loadOrderTypeOption() {
      this.$http({
        url: api.basOrderType.getListUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.orderTypeOptions = []
        res.data.data.forEach(item => {
          this.orderTypeOptions.push({
            value: item.id,
            label: item.orderTypeName
          })
        })
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      this.requestParam.tabStat = this.goodsStatusItem
      this.flushed()
    },

    // 加载table数据
    getTableData() {
      this.$objCopy(this.formData, this.requestParam)

      let tableOption = {
        vue: this,

        tableRef: 'table-m1',
        path: api.exceptionRecall.getListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
      this.activeName = 'second';
    },

    // 搜索
    searchEvent() {
      this.requestParam.searchValueIsEnable = !this.show3

      this.requestParam.searchValue = this.searchValue
      this.requestParam.orderTypeId = this.formData.orderTypeId
      this.requestParam.serviceTypeId = this.formData.serviceTypeId
      this.requestParam.userName = this.formData.userName
      this.requestParam.userMobile = this.formData.userMobile
      this.requestParam.recallTag = this.formData.recallTag
      this.requestParam.completeTimeBegin = this.formData.completeTimeBegin
      this.requestParam.completeTimeEnd = this.formData.completeTimeEnd

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.loadTabOption()
      this.flushed()
    },

    // 加载tab数据
    loadTabOption() {

      this.$http({
        url: api.exceptionRecall.getCountUrl,
        method: 'post',
        data: this.requestParam,
      }).then(res => {
        this.goodsStatusList = res.data.data
      })
    },

    // 重置
    resetEvent() {
      this.formData = {
        feeType: '',
        name: ''
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.feeType = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////


    addressClickEvent(row, id) {
      this.openEditDialog(row.orderId);
      console.log(row, id, "row");
    },


    openEditDialog(id) {

      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-select__tags > span{
  display: flex !important;;
}
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}


::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}


::v-deep .el-cascader--medium {

  height: 38px;
}

.icon_w {
  width: 7px;
}
</style>
